import {HTMLAttributes} from 'react'
import {StyledPageBody, StyledPageCardWrapper, StyledPageContent, StyledPageHeading, StyledPageWrapper} from './style'
import {FlexboxProps} from '@/components/ui/flexbox/FlexBox'

export const PageWrapper = (props: HTMLAttributes<HTMLDivElement>) => <StyledPageWrapper {...props} />
export const PageBody = (props: HTMLAttributes<HTMLDivElement>) => <StyledPageBody {...props} />
export const PageHeading = (props: FlexboxProps<'div'>) => <StyledPageHeading {...props} />
export const PageContent = ({padding, ...props}: HTMLAttributes<HTMLDivElement> & {padding?: number}) => (
    <StyledPageContent {...props} $padding={padding} />
)
export const PageCardWrapper = (props: HTMLAttributes<HTMLDivElement>) => <StyledPageCardWrapper {...props} />
